<template>
  <div class="mt-5 mx-4">
    <br />
    <br />
    <br />
    <br />
    <v-card color="grey darken-2" class="white--text pa-2">
      <v-row>
        <v-col>
          <p class="mt-2">Filter:</p>
        </v-col>
        <v-col>
          <v-select dark placeholder="Gemeinde" color="white" outlined>
          </v-select>
        </v-col>
        <v-col>
          <v-select dark placeholder="Thema" color="white" outlined> </v-select>
        </v-col>
        <v-col>
          <v-select dark placeholder="Zeitraum" color="white" outlined>
          </v-select>
        </v-col>
      </v-row>
    </v-card>
    <v-row class="my-0" v-for="index in 10" :key="index">
      <v-col class="ma-2" v-for="index in 3" :key="index">
        <v-card class="mx-auto mt-0" max-width="100%">
          <v-img
            class="white--text align-end"
            height="300px"
            src="https://static.wixstatic.com/media/f6a051_f82b7b43989b42c2ba688bcee3025dd1~mv2.jpg/v1/crop/x_407,y_674,w_2778,h_1579/fill/w_400,h_220,al_c,q_80,usm_0.66_1.00_0.01/DSC03517_JPG.webp"
            gradient="to top right, rgba(0,0,0,.33), rgba(0,0,0,.33)"
          >
            <v-card-title class="white--text">Sommerprojekt 1</v-card-title>
          </v-img>

          <v-card-subtitle class="pb-0">
            <div>01.06 - 10.06.2021</div>
          </v-card-subtitle>

          <v-card-text class="text--primary">
            <v-chip color="primary" class="mr-1 mb-1">Algund</v-chip>
            <v-chip class="mr-1 mb-1">Singen</v-chip>
            <v-chip class="mr-1 mb-1">Malen</v-chip>
            <v-chip class="mr-1 mb-1">Basteln</v-chip>
            <hr class="mx-1 my-2" />
            <div>
              Das ist die Beschreibung zum spannenden Sommerprojekt, welche wir
              in Wirklichkeit auf X Zeichen begrenzen.
            </div>
          </v-card-text>

          <v-card-actions>
            <v-btn color="orange">
              mehr
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "app-course-overview"
};
</script>
